// TODO: This should be renamed to `DashpivotPlanTypes`.
// There's too many references to it atm. Should be handled on a different ticket.
export var CompanyPlanTypes;
(function (CompanyPlanTypes) {
    CompanyPlanTypes["FreeTrial"] = "free trial";
    CompanyPlanTypes["Legacy"] = "legacy";
    CompanyPlanTypes["Standard"] = "standard";
    CompanyPlanTypes["Pro"] = "pro";
    CompanyPlanTypes["Enterprise"] = "enterprise";
})(CompanyPlanTypes || (CompanyPlanTypes = {}));
